// Browser-tab titles and visible headings for every device-claim stage.
// Titles never include customer names, addresses, claim codes or tokens.
export const CLAIM_STAGES = {
  LOOKUP: "lookup",
  SIGN_IN: "sign_in",
  CUSTOMER: "customer",
  ADDRESS: "address",
  CONTACTS: "contacts",
  ASSET_DEVICE: "asset_device",
  ALERTS: "alerts",
  PROVIDERS: "providers",
  REVIEW: "review",
  SUBMITTING: "submitting",
  FINISHING: "finishing",
  SETUP_ATTENTION: "setup_attention",
  ASSIGNMENT_ATTENTION: "assignment_attention",
  COMPLETE: "complete",
  HISTORY: "history",
  UNAVAILABLE: "unavailable",
  ERROR: "error",
};

const COPY = {
  [CLAIM_STAGES.LOOKUP]: ["Loading device claim", "Loading device claim"],
  [CLAIM_STAGES.SIGN_IN]: ["Sign in to install device", "Sign in to install this device"],
  [CLAIM_STAGES.CUSTOMER]: ["Customer - Device installation", "Customer"],
  [CLAIM_STAGES.ADDRESS]: ["Service address - Device installation", "Service address"],
  [CLAIM_STAGES.CONTACTS]: ["Contacts & access - Device installation", "Contacts & device access"],
  [CLAIM_STAGES.ASSET_DEVICE]: ["Asset & device - Device installation", "Tank / asset & device"],
  [CLAIM_STAGES.ALERTS]: ["Alert settings - Device installation", "Alert settings"],
  [CLAIM_STAGES.PROVIDERS]: ["Provider sharing - Device installation", "Provider sharing"],
  [CLAIM_STAGES.REVIEW]: ["Review & confirm - Device installation", "Review & confirm installation"],
  [CLAIM_STAGES.SUBMITTING]: ["Installing device", "Saving installation"],
  [CLAIM_STAGES.FINISHING]: ["Finishing device setup", "Installation saved - finishing setup"],
  [CLAIM_STAGES.SETUP_ATTENTION]: ["Setup needs attention", "Installation saved - setup needs attention"],
  [CLAIM_STAGES.ASSIGNMENT_ATTENTION]: [
    "Assignment needs attention",
    "Customer saved - device assignment needs attention",
  ],
  [CLAIM_STAGES.COMPLETE]: ["Installation complete", "Installation complete"],
  [CLAIM_STAGES.HISTORY]: ["Installation history", "Installation summary"],
  [CLAIM_STAGES.UNAVAILABLE]: ["Claim unavailable", "Claim unavailable"],
  [CLAIM_STAGES.ERROR]: ["Device claim error", "Unable to load or start installation"],
};

const UNAVAILABLE_HEADINGS = {
  expired: "Claim expired",
  revoked: "Claim revoked",
};

export function unavailableReason(value) {
  const text = String(value || "").toLowerCase();
  if (text.includes("expire")) return "expired";
  if (text.includes("revoke") || text.includes("device_installed")) return "revoked";
  return "unavailable";
}

export function claimStageCopy(stage, { reason } = {}) {
  const [title, heading] = COPY[stage] || COPY[CLAIM_STAGES.LOOKUP];
  if (stage === CLAIM_STAGES.UNAVAILABLE) {
    return { title: `${title} | Rivio`, heading: UNAVAILABLE_HEADINGS[reason] || heading };
  }
  return { title: `${title} | Rivio`, heading };
}

// Stage for the combined review/completion surface, derived from the verified
// outcome rather than the local intent.
export function outcomeStage({ submitting, completed, customerSaved, assignmentFailed, operations }) {
  if (submitting) return CLAIM_STAGES.SUBMITTING;
  if (!completed) {
    if (customerSaved && assignmentFailed) return CLAIM_STAGES.ASSIGNMENT_ATTENTION;
    return null;
  }
  const rows = operations || [];
  if (rows.some((row) => row.status === "failed")) return CLAIM_STAGES.SETUP_ATTENTION;
  if (rows.some((row) => row.status !== "saved" && row.status !== "not_selected")) return CLAIM_STAGES.FINISHING;
  return CLAIM_STAGES.COMPLETE;
}
